module.exports = __webpack_public_path__ + "media/images/site-logo-a8bb5b0c.png";